import { Application } from '@hotwired/stimulus'

console.log("controllers/application.js loaded!")
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

console.log('glightbox loaded')

window.addEventListener('turbo:load', function () {
  // Enable click events on thumbnails
  const thumbnails = document.querySelectorAll('a.glightbox')
  thumbnails.forEach(function (thumbnail) {
    thumbnail.classList.remove('disabled')
  })
  const openThumbnails = document.querySelectorAll('a.open-glightbox')
  openThumbnails.forEach(function (thumbnail) {
    thumbnail.classList.remove('disabled')
  })
  // Get references to the checkboxes
  var carSoldCheckbox = document.getElementById('car_sold')
  var carReservedCheckbox = document.getElementById('car_reserved')
  var carShowSoldOnPublic = document.getElementById('show-sold-on-public')

  if (carSoldCheckbox && carReservedCheckbox) {
    carSoldCheckbox.addEventListener('click', handleCheckboxClick)
    carReservedCheckbox.addEventListener('click', handleCheckboxClick)
    if(carSoldCheckbox.checked) {
      carShowSoldOnPublic.classList.remove('d-none')
    } else {
      carShowSoldOnPublic.classList.add('d-none')
    }
  }

  const thumbs = document.querySelectorAll('a.open-glightbox')
  if (thumbs) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', handleThumbClick)
    })
  }
})

// Function to handle the mutual exclusivity
function handleCheckboxClick(event) {
  // Check if the clicked checkbox is checked
  if (event.target.checked) {
    // Uncheck the other checkbox
    if (event.target === carSoldCheckbox) {
      carReservedCheckbox.checked = false
      if(carSoldCheckbox.checked) {
        carShowSoldOnPublic.classList.remove('d-none')
      } else {
        carShowSoldOnPublic.classList.add('d-none')
      }
    } else if (event.target === carReservedCheckbox) {
      carSoldCheckbox.checked = false
    }
  }
}

function handleThumbClick(event) {
  event.preventDefault()
  const thumb = event.target
  if (thumb) {
    const index = thumb.dataset.lightboxIndex
    console.log(index)
    if (index) {
      lightbox.openAt(index)
      console.log('controllers/application.js handleThumbClick lightbox.openAt(' + index + ')')
    }
  }
}

export { application }
